import { createContext, useContext, useState, useEffect } from 'react'

const PageTitleContext = createContext(null)

export function PageTitleProvider({ children }) {
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')

  return (
    <PageTitleContext.Provider value={{ title, setTitle, description, setDescription }}>
      {children}
    </PageTitleContext.Provider>
  )
}

// Hook for pages to set their title and optional description — automatically sets via useEffect
export function usePageTitle(pageTitle, pageDescription = '') {
  const ctx = useContext(PageTitleContext)

  useEffect(() => {
    if (ctx) {
      ctx.setTitle(pageTitle)
      ctx.setDescription(pageDescription)
    }
  }, [pageTitle, pageDescription, ctx])

  return ctx
}

// Hook for layout to read the current title
export function useCurrentPageTitle() {
  const ctx = useContext(PageTitleContext)
  return ctx?.title ?? ''
}

// Hook for layout to read the current description
export function useCurrentPageDescription() {
  const ctx = useContext(PageTitleContext)
  return ctx?.description ?? ''
}
